module.exports = __webpack_public_path__ + "static/media/cash-register.1b77a6fd.svg";